<div class="fx-column">
  <div class="graph-nice-container" [style.height.px]="height">
    <div class="fx-row align-items-center justify-content-start w-100">
      <div id="graphnicediv" #graphnicediv class="graph-nice" [class.fx-flex-60]="classBalance.display"
        *ngIf="!error && !noData" [style.height.px]="height">
      </div>
      <!-- <mat-progress-spinner class="main-spinner" mode="indeterminate" diameter="25" *ngIf="loading && !error && !noData">
    </mat-progress-spinner> -->
      <div class="fx-row fx-wrap align-items-center justify-content-center fx-flex-40 class-balance"
        *ngIf="classBalance.display" [style.height.px]="height">

        <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-100 mb-10">
          <span class="text fx-flex-100">{{('CASE.CLASS_INSIGHTS' | translate)}}</span>
          <!-- Only display insight if more than 1 class, otherwise it's useless -->
          <div class="fx-row fx-wrap align-items-center justify-content-start mt-5"
            *ngIf="classBalance.classes.length > 1">
            <div class="bullet smaller plain mr-5" [class.green]="classBalance.qualification === 'good'"
              [class.orange]="classBalance.qualification === 'average'"
              [class.red]="classBalance.qualification === 'bad'">
            </div>
            <span class="small dark" *ngIf="classBalance && classBalance.qualification"
              [class.green]="classBalance.qualification === 'good'"
              [class.orange]="classBalance.qualification === 'average'"
              [class.red]="classBalance.qualification === 'bad'">{{'CASE.CLASS_BALANCE_'+classBalance.qualification.toUpperCase()
              | translate}}</span>
          </div>
        </div>
        <!-- But keep no of docs per class as it can show users that lots of linked documents are not linked to the case class -->
        <div class="fx-row align-items-center justify-content-start fx-flex-100 mb-8"
          *ngFor="let top of classBalance.insights">
          <div class="fx-column fx-flex">
            <div class="fx-row align-items-center justify-content-between">
              <span class="small bold">{{('NICE_CLASSES.CLASS_NUMBER' | translate)}}{{top.class}}</span>
              <span class="small light ml-8" [class.red]="top.count === 0">{{top.count}} {{('ENTITIES.DOCUMENT_S'
                | translate).toLowerCase()}}</span>
            </div>
            <app-progress-bar [mode]="'determinate'" [value]="top.percent" [loading]="true"></app-progress-bar>
          </div>
        </div>
      </div>
    </div>

    <div class="fx-column align-items-center justify-content-center" *ngIf="error">
      <mat-icon class="red mb-5" fontSet="material-icons-outlined">error</mat-icon>
      <span class="text light">{{'DOCUMENTS_REPORT.ERROR' | translate}}</span>
    </div>
    <div class="fx-column align-items-center justify-content-center" *ngIf="!loading && noData">
      <span class="text light">{{'DOCUMENTS_LIST.SEARCH_NO_DOCUMENTS' | translate}}</span>
    </div>
  </div>
</div>